const licenseRegistrationBarChartData = {
  labels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  datasets: [
    {
      label: "Pass",
      data: [120, 190, 130, 170, 160, 150, 180, 170, 160, 190, 200, 210],
      backgroundColor: "rgba(9, 89, 11, 0.5)",
    },
    {
      label: "Fail",
      data: [90, 120, 100, 140, 130, 110, 150, 140, 130, 160, 170, 180],
      backgroundColor: "rgba(228, 20, 65, 0.5)",
    },
  ],
};

export default licenseRegistrationBarChartData;
